import { Box } from "@mui/material";
import Header from "../../../components/Header";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  getVariationLoading,
  getVariations,
} from "../../../features/variationSlice";
import { addTypeVariation, getTypeVariationError, getTypeVariationStatus, getTypeVariationSuccess } from "../../../features/typeVariationSlice";
import { updateStatus } from "../../../features/typeSlice";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import VariationForm from "./variationForm";
import BackButton from "../../../components/backButton";
import { useTranslation } from "react-i18next";

const AddTypeVariation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { restaurantId } = useRestaurant();
  const status = useSelector(getTypeVariationStatus);
  const error = useSelector(getTypeVariationError);
  const loading = useSelector(getVariationLoading);
  const success = useSelector(getTypeVariationSuccess);

  const initialValues = {
    name: "",
    label: "",
    message: "",
    variations: [],
  };

  useEffect(() => {
    dispatch(getVariations(restaurantId));
  }, [dispatch, restaurantId]);

  const handleFormSubmit = (values) => {
    dispatch(
      addTypeVariation({
        body: {
          name: values.name,
          label: values.label,
          description: values.message,
          variations: values.variations,
        }, restaurantId
      })
    );
  };
  
  useEffect(() => {
    if (status === "addSuccess") {
      toast.success(success);
      dispatch(updateStatus());
      navigate("/typeVariation");
    } else if (status === "addError") {
      toast.error(error);
    }
  }, [status, error, dispatch, navigate, success]);

  return (
    <Box m="20px" className="main-application">
      <BackButton/>
      <Header
        title={t("headers.addTypeVariation")}
        subtitle={t("headers.addTypeVariationSub")}
      />
      <VariationForm
        buttonText={t("common.submit")}
        handleFormSubmit={handleFormSubmit}
        initialValues={initialValues}
        loading={loading}
      />
    </Box>
  );
};

export default AddTypeVariation;
